export default function Header() {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-semibold">Medicines</h1>

      <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg cursor-pointer transition">
        + Add Medicine
      </button>
    </div>
  );
}
